import { StatusTextMap } from "components/parts/Label/StatusLabel/StatusLabel";
import { decideSubjectStatus } from "pages/SubjectManagement/hook";
import React from "react";
import { InterviewType, Subject } from "types/graphqlapi";
import { fetchMonitorBysubjectIdQuery } from "utils/apis/monitor";
import { getSubjectQuery } from "utils/apis/subject";
import { getAdminUserQuery, getUserByIdQuery } from "utils/apis/user";
import { InterviewTypeTextMapper } from "utils/common";

export type ClientSubject = {
  main_user_name_asmarq?: string | null;
  main_user_name_group?: string | null;
  status: string;
  interviewTypeDescription: string;
} & Subject;

export const useSubject = (subjectId: string) => {
  const [clientSubjectData, setClientSubjectData] =
    React.useState<ClientSubject>();

  const fetchClientSubjectData = React.useCallback(async () => {
    const subjectData = await getSubjectQuery(subjectId);
    if (!subjectData) return;

    const asmarqMainUserId = subjectData.main_user_id_asmarq;
    const groupMainUserId = subjectData.main_user_id_group;
    const canceled = subjectData.canceled;
    if (typeof canceled !== "number") return;

    const clientSubjectData: ClientSubject = {
      ...subjectData,
      main_user_name_asmarq: asmarqMainUserId
        ? await getAdminUserQuery(asmarqMainUserId).then((value) => value?.name)
        : null,
      main_user_name_group: groupMainUserId
        ? await getUserByIdQuery(groupMainUserId).then((value) => value?.name)
        : null,
      status: StatusTextMap[await decideSubjectStatus(subjectData)],
      interviewTypeDescription: InterviewTypeTextMapper(
        subjectData.interview_type || InterviewType.ONE_TIME
      ),
    };

    setClientSubjectData(clientSubjectData);
  }, [subjectId]);

  const getMonitorListBySubjectId = async () => {
    const monitorList = await fetchMonitorBysubjectIdQuery(subjectId);
    return monitorList;
  };

  React.useEffect(() => {
    fetchClientSubjectData();
  }, [fetchClientSubjectData]);

  return { clientSubjectData, getMonitorListBySubjectId };
};
